export default __webpack_public_path__ + "static/mobile_10-983a44759d00d2f325446dbfcdae1156.webp";